const apiKey = "m2TbTzFjbW4R2w4W";

// const apiKey = "DPyF4KAdI0F2cGT6";

export default apiKey;
